// 검사 문항 배치 엔진
// 같은 내용을 서로 다른 표현으로 물은 병렬 문항(groupId가 같은 문항)이
// 연달아 나오지 않도록, 그룹(groupId)을 순환(라운드 로빈)하며
// 문항을 흩어서 배치한다. 이렇게 하면 응답자가 '같은 질문 반복'을 눈치채지 못해
// 일관성 측정이 더 정확해진다.

export function interleaveQuestions<T extends { type: string; groupId: string }>(
  questions: T[],
): T[] {
  // groupId별로 문항을 묶되, 배열에 등장한 순서를 보존한다.
  const groupMap = new Map<string, T[]>();
  const groupOrder: string[] = [];

  questions.forEach((q) => {
    if (!groupMap.has(q.groupId)) {
      groupMap.set(q.groupId, []);
      groupOrder.push(q.groupId);
    }
    groupMap.get(q.groupId)!.push(q);
  });

  const groups = groupOrder.map((gid) => groupMap.get(gid)!);

  // 각 그룹의 n번째 문항을 한 번씩 순회하며 결과를 쌓는다.
  // 예: r1(3문항), r2(3문항) → r1[0], r2[0], r1[1], r2[1], r1[2], r2[2]
  const result: T[] = [];
  const maxLen = Math.max(...groups.map((g) => g.length));

  for (let i = 0; i < maxLen; i++) {
    groups.forEach((g) => {
      if (i < g.length) result.push(g[i]);
    });
  }

  return result;
}